import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://fast-alu.fr";
const DEFAULT_IMAGE = "https://fast-alu.fr/og-fast-alu.png";

export const buildLocalBusinessSchema = ({ city }) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Fast Alu",
  url: SITE_URL,
  image: DEFAULT_IMAGE,
  telephone: "+33184160307",
  email: "contact@fast-alu.com",
  areaServed: [city, "Val-de-Marne", "Île-de-France"],
  serviceType: [
    "Menuiserie aluminium",
    "Métallerie",
    "Automatismes",
    "Dépannage rideaux métalliques",
  ],
});

const Seo = ({ title, description, image = DEFAULT_IMAGE, schema }) => {
  const location = useLocation();
  const canonical = `${SITE_URL}${location.pathname === "/" ? "" : location.pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};

export default Seo;
